// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2105":"e10d80ad","9165":"3d3ed636"}[chunkId] + ".chunk.css");